import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import UIGrid from '../uigrid';
import Notification from '../../shared/notification-modal';
import { defaultModalOptions } from '../../shared/constantVariable';
// import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'; // Optional theme CSS

const CLRoTable = (props) => {
  const { colDefArr, option, rowData, handleAfterBlur, handleClick, onValueChange } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  useEffect(() => {
    $('.clro-table_container .row_1 input').attr('disabled', null);
    $('.clro-table_container .row_1 select').attr('disabled', null);
    $('.clro-table_container #input_num1_1').attr('disabled', true);
    $('.clro-table_container #input_num1_12').attr('disabled', true);
    $('.clro-table_container #input_num1_13').attr('disabled', true);
    $('.clro-table_container #input_num1_14').attr('disabled', true);
    // $('.clro-table_container select').css({ 'min-width': '13vw', 'max-width': '13vw' });
  }, []);
  return (
    <div>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div className="clro-table_container ag-theme-alpine sansW4SeLig" style={{ height: 'auto', 'border': '1px solid #B2E7EE !important' }}>
        <UIGrid
          data={rowData}   // array of row data [{1st row}, {2nd row}]
          properties={colDefArr}  // header and data value
          onblur={handleAfterBlur}
          onchange={onValueChange}
          options={option}
          onclick={handleClick}
        />
      </div>
    </div>
  );
};

export default CLRoTable;